<sf-filter filterName="Filter Posts" (searchFired)="search()" (resetFired)="reset()" [isCollapsed]="isCollapsed">
    <form [formGroup]="filterForm">
        <div class="row mb-2">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12 col-xl-6">
                        <label class="form-label form-label-sm">Engineer</label>
                        <ng-select
                            [items]="postsStore.engineers()"
                            bindValue="id"
                            bindLabel="fullName"
                            placeholder="Engineer"
                            formControlName="staffId">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <sf-staff-select-option [staff]="item" showPicture showColour /> </ng-template
                        ></ng-select>
                    </div>
                    <div class="col-12 col-xl-6">
                        <label class="form-label form-label-sm">Type</label>
                        <ng-select
                            [items]="postsStore.postListPostTypes()"
                            bindValue="id"
                            bindLabel="name"
                            placeholder="Type"
                            formControlName="postTypeId">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <span [ngOptionHighlight]="search">{{ item.name }}</span>
                            </ng-template></ng-select
                        >
                    </div>
                    <div class="col-md-6 mt-3">
                        <sf-switch
                            label="Show Processed Posts"
                            inputId="isProcessed"
                            formControlName="isProcessed"></sf-switch>
                        <sf-switch label="Show Voided Posts" inputId="isVoid" formControlName="isVoid"></sf-switch>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6"></div>
                </div>
            </div>

            <div class="offset-lg-1 col-lg-3">
                <sf-input-dropdown
                    label="Sort By"
                    inputId="sortColumn"
                    [items]="sortOptions"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="sortColumn"></sf-input-dropdown>
            </div>
            <div class="col-lg-2">
                <sf-input-dropdown
                    label="Page Size"
                    inputId="pageSize"
                    [items]="[10, 20, 30, 40, 50, 60]"
                    formControlName="pageSize"></sf-input-dropdown>
            </div>
        </div>
    </form>
</sf-filter>
